import React from 'react';
import './LegalPage.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1 className="legal-page__title heading-1">Privacy Policy</h1>
        <p className="legal-page__updated">Last updated: February 2026</p>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">1. Introduction</h2>
          <p>
            Furudio ("we", "our", or "us") is committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard 
            your information when you visit our website or use our services.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">2. Information We Collect</h2>
          <p>We may collect information about you in a variety of ways, including:</p>
          <ul className="legal-page__list">
            <li>
              <strong>Personal Data:</strong> Name, email address, company name, 
              and role that you voluntarily provide when contacting us via email.
            </li>
            <li>
              <strong>Analytics Data:</strong> We use Vercel Analytics to understand 
              how visitors use our website. This service collects anonymous, aggregated 
              data such as page views and visitor counts. Vercel Analytics does not use 
              cookies, does not collect personal information, and does not track 
              individual users across websites.
            </li>
          </ul>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul className="legal-page__list">
            <li>Respond to your inquiries and provide customer support</li>
            <li>Send you updates about our product and services</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">4. Data Sharing</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal information 
            to third parties without your consent, except as required by law or to 
            trusted service providers who assist us in operating our website and 
            conducting our business.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect 
            your personal information against unauthorized access, alteration, disclosure, 
            or destruction.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">6. Your Rights</h2>
          <p>
            Under GDPR and applicable data protection laws, you have the right to access, 
            correct, delete, or restrict the processing of your personal data. To exercise 
            these rights, please contact us at{' '}
            <a href="mailto:info@furudio.com">info@furudio.com</a>.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading heading-3">7. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:{' '}
            <a href="mailto:info@furudio.com">info@furudio.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
